import { useState } from 'react';
import { Button } from '../../../components/Form/Button';
import { Input } from '../../../components/Form/Input';
import { updateUserProfileAction } from '../../auth/authActions';
import { useAuthStore } from '../../auth/authStore';
import Card from './card/Card';
import CardBody from './card/CardBody';
import CardHeader from './card/CardHeader';

const UserSettingsCard = () => {
  const auth = useAuthStore((state) => state.auth);
  const [changesMade, setChangesMade] = useState(false);
  const [formData, setFormData] = useState({
    firstName: auth?.firstName || '',
    lastName: auth?.lastName || '',
    displayName: auth?.displayName || '',
  });

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Map input names to UserProfile keys
    const keyMap: Record<string, keyof typeof formData> = {
      firstName: 'firstName',
      lastName: 'lastName',
      displayName: 'displayName',
    };
    const profileKey = keyMap[name];
    if (profileKey && value === auth?.[profileKey]) {
      setChangesMade(false);
    } else {
      setChangesMade(true);
    }
  };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!changesMade) return;

    try {
      const { firstName, lastName, displayName } = formData;
      await updateUserProfileAction({ firstName, lastName, displayName });
      setChangesMade(false);
    } catch (error) {
      console.error('Error updating user profile:', error);
      // Handle error
      // (e.g., show an error message)
    }
  };

  return (
    <Card>
      <CardHeader>
        <div className='flex flex-col w-full ml-1'>
          <div className='flex items-center justify-between w-full'>
            <div className='flex items-center mt-2'>
              <h3 className='text-base font-semibold text-gray-900'>
                User Settings
              </h3>
            </div>
            <div className='ml-4 mt-2 shrink-0'>
              {changesMade && (
                <Button
                  type='submit'
                  variant='primary'
                  form='update-user-form'
                  className='flex items-center'
                >
                  <span className='ml-1'>Save</span>
                </Button>
              )}
            </div>
          </div>
        </div>
      </CardHeader>
      <CardBody>
        <form
          name='update-user-form'
          id='update-user-form'
          className='mt-2 grid grid-cols-2 gap-x-2 gap-y-4'
          onSubmit={handleSubmit}
        >
          <div className='col-span-1 w-full'>
            <Input
              name='firstName'
              label='First Name'
              defaultValue={auth?.firstName}
              className='w-full'
              placeholder='John'
              onChange={handleInputChange}
            />
          </div>
          <div className='col-span-1 w-full'>
            <Input
              name='lastName'
              className='w-full'
              label='Last Name'
              defaultValue={auth?.lastName}
              placeholder='Smith'
              onChange={handleInputChange}
            />
          </div>
          <div className='col-span-2 w-full'>
            <Input
              name='displayName'
              className='w-full'
              label='Display Name'
              defaultValue={auth?.displayName}
              placeholder='John Smith'
              onChange={handleInputChange}
            />
          </div>
        </form>
      </CardBody>
    </Card>
  );
};
export default UserSettingsCard;
